import { render } from "./DashboardElement.vue?vue&type=template&id=858f674a&scoped=true&ts=true"
import script from "./DashboardElement.vue?vue&type=script&lang=ts"
export * from "./DashboardElement.vue?vue&type=script&lang=ts"

import "./DashboardElement.vue?vue&type=style&index=0&id=858f674a&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-858f674a"]])

export default __exports__